import { qs } from '@/shared/lib/http'

/**
 * Ghost Content API 클라이언트. 소식·이야기 글은 Ghost 가 정본이다(운영 `/news/`).
 *
 * 우리 서버의 `/api` 와 달리 Ghost 는 별개 제품이라 OpenAPI 생성물이 없다 — 여기 타입은 수기다.
 */
const BASE = '/news/ghost/api/content'

// 읽기 전용 Content API Key.
const CONTENT_KEY = 'd98374f0ada34098f67eb0d7fd'

export interface GhostTag {
  slug: string
  name: string
}

export interface GhostPost {
  id: string
  slug: string
  title: string
  excerpt: string | null
  feature_image: string | null
  published_at: string | null
  html: string | null
  tags?: GhostTag[]
}

export interface GhostPagination {
  page: number
  pages: number
  total: number
}

export interface GhostPostsResponse {
  posts: GhostPost[]
  meta: { pagination: GhostPagination }
}

async function ghostRequest<T>(path: string, params: Record<string, string | number>): Promise<T> {
  const res = await fetch(`${BASE}${path}${qs({ key: CONTENT_KEY, ...params })}`)
  if (!res.ok) throw new Error(`Ghost 응답 오류 (${String(res.status)})`)

  return (await res.json()) as T
}

/**
 * 태그 하나에 달린 글 목록.
 *
 * `q` 는 **제목만** 훑는다 — Content API 는 본문 전문 검색을 주지 않는다(NQL `title:~`).
 * 작은따옴표는 NQL 의 문자열 구분자라 검색어에서 뺀다.
 */
export function fetchGhostPosts(
  tag: string,
  q: string,
  page: number,
  limit: number,
): Promise<GhostPostsResponse> {
  const filters = [`tag:${tag}`]
  const needle = q.replaceAll("'", '').trim()
  if (needle !== '') filters.push(`title:~'${needle}'`)

  return ghostRequest<GhostPostsResponse>('/posts/', {
    limit,
    page,
    include: 'tags',
    filter: filters.join('+'),
  })
}

export async function fetchGhostPostBySlug(slug: string): Promise<GhostPost | null> {
  const res = await ghostRequest<{ posts: GhostPost[] }>(`/posts/slug/${slug}/`, {
    include: 'tags',
  })
  return res.posts[0] ?? null
}
